(function() {
  var ScrollHelper, ValidationEngine,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ScrollHelper = App.load("core::ScrollHelper");

  ValidationEngine = App.loadClass("core::ValidationEngine");

  exports.Layer_Prescription_Map_Dialog = (function(superClass) {
    extend(Layer_Prescription_Map_Dialog, superClass);

    function Layer_Prescription_Map_Dialog() {
      this.editLayer = bind(this.editLayer, this);
      this.submitAction = bind(this.submitAction, this);
      return Layer_Prescription_Map_Dialog.__super__.constructor.apply(this, arguments);
    }

    Layer_Prescription_Map_Dialog.prototype.is_export = false;

    Layer_Prescription_Map_Dialog.prototype.init = function() {
      var soil, soil_obj;
      if (this.loadLayoutPostOptions == null) {
        this.loadLayoutPostOptions = {};
      }
      this.layoutUrl = 'backend/grower/layers/prescription-map/load-layout';
      this.classes = 'large_dialog';
      this.submitBindings = true;
      if (this.is_export) {
        this.loadLayoutPostOptions.hybrids_id = this.export_params.hybrids_id;
      }
      if (this.loadLayoutPostOptions.id != null) {
        this.newLayer = false;
        this.saveUrl = 'backend/grower/layers/prescription-map/update';
      } else {
        this.newLayer = true;
        this.saveUrl = 'backend/grower/layers/prescription-map/add';
      }

      /*
      This is stupid and overcomplicated. Basically, soils needs to be displayed before
      we load the dialog, because DISPLAYING SOILS creates the user soil colors, which are required
      for prescription maps to display correctly
       */
      $(window).unbind('Data.Soils.loaded').bind('Data.Soils.loaded', (function(_this) {
        return function() {
          $(window).unbind('Data.Soils.loaded');
          return _this.createDialog();
        };
      })(this));
      soil_obj = $(this.parent.layoutSelector).find('[data-layertype="soils"]');
      if (soil_obj.length > 0) {
        if (soil_obj.parents('tr').data('layer_object') == null) {
          soil_obj.parents('td').trigger('click');
        } else {
          this.createDialog();
        }
      } else {
        if (!this.is_export) {
          soil = this.createSubHandler('grower::handlers/data/layers/Layer_Soil');
        }
        if (soil != null) {
          soil.loadLayoutPostOptions = $.extend(true, {}, this.loadLayoutPostOptions);
          soil.loadLayoutPostOptions.id = this.loadLayoutPostOptions.fields_id;
          soil.init();
        } else {
          this.createDialog();
        }
      }
      this.successAction = (function(_this) {
        return function() {
          if (_this.formKO.layer().layer_name() == null) {
            return false;
          }
          if (App.sidebar.contentDiv().find("#dataList tr").length > 0) {
            return App.sidebar.contentDiv().find("#dataList tr[data-layer_id='" + _this.loadLayoutPostOptions.id + "'] td").eq(0).find('.layer_type').html("Prescription Map " + (_this.formKO.layer().layer_name()));
          }
        };
      })(this);
      return this.validator = new ValidationEngine();
    };

    Layer_Prescription_Map_Dialog.prototype.afterLoadLayout = function(selector, response) {
      var base, koClass, ref;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      this.dialog.find('.message_writer').addClass('absolute-errorDiv');
      this.dialog.find('.message_writer').message_writer('setInitialClass');
      setTimeout((function(_this) {
        return function() {
          ScrollHelper.make(_this.dialog.find('.rx-table'), {
            height: 300,
            width: "" + (_this.dialog.find('.form-container').width() - 5),
            footer: true,
            forceHeight: true
          });
          return _this.setPosition();
        };
      })(this), 200);
      if ((response.data.prescription_map != null) && response.data.prescription_map.hybrids_id) {
        this.is_export = true;
      }
      if (this.is_export) {
        if ((base = response.data).prescription_map == null) {
          base.prescription_map = {};
        }
        response.data.prescription_map = $.extend(this.export_params, response.data.prescription_map);
        koClass = App.loadClass("grower::viewmodels/prescription_map/export/Form");
      } else {
        koClass = App.loadClass("grower::viewmodels/prescription_map/Form");
      }
      this.formKO = new koClass(this, response.data);
      ko.applyBindings(this.formKO, this.dialog[0]);
      if (this.is_export && this.newLayer && this.formKO.layer().target_population !== 0) {
        this.formKO.recalcPopulations();
      }
      if (this.startEditing) {
        this.formKO.setEditing();
      }
      this.dialog.find('.hover-yield').tooltip({
        title: 'Yield Productivity potential in bushels per acre is estimated by USDA when collecting SSURGO Soil data. Values are not representative of modern corn yields, but provide a guide for relative soil type performance',
        placement: 'bottom'
      });
      this.dialog.find('.hover-soil-type').tooltip({
        placement: 'bottom',
        title: 'test'
      });
      this.validator.makeFormValidator('rx_map', '#frm_rx_map', '#rx_map_errors', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.save('Saving...');
          } else {

          }
        };
      })(this));
      this.dialog.find('.rx_map-recalc_btn').bind('click', (function(_this) {
        return function(e) {
          return _this.validator.validateForm('rx_map', false);
        };
      })(this));
      this.validator.registerRule({
        'selector': '.validate-max-pop-gt-min',
        'text': 'Max Pop must be greater than Min Pop',
        'func': (function(_this) {
          return function(elem) {
            if ((_this.formKO.layer().max_population() == null) || (_this.formKO.layer().min_population() == null)) {
              return true;
            }
            if (parseInt(_this.formKO.layer().max_population()) < parseInt(_this.formKO.layer().min_population())) {
              return false;
            }
            return true;
          };
        })(this)
      });
      this.validator.registerRule({
        'selector': '.validate-max-diff-gt-min',
        'text': 'Max Pop Diff must be greater than Min Pop Diff',
        'func': (function(_this) {
          return function(elem) {
            if ((_this.formKO.layer().max_pop_diff() == null) || (_this.formKO.layer().min_pop_diff() == null)) {
              return true;
            }
            if (parseInt(_this.formKO.layer().max_pop_diff()) < parseInt(_this.formKO.layer().min_pop_diff())) {
              return false;
            }
            return true;
          };
        })(this)
      });
      return this.validator.registerRule({
        'selector': '.validate-target-in-range',
        'text': 'Target Population must be between Min and Max Pop',
        'func': (function(_this) {
          return function(elem) {
            if ((_this.formKO.layer().min_population() != null) && _this.formKO.layer().target_population() < _this.formKO.layer().min_population()) {
              return false;
            }
            if ((_this.formKO.layer().max_population() != null) && _this.formKO.layer().target_population() > _this.formKO.layer().max_population()) {
              return false;
            }
            return true;
          };
        })(this)
      });
    };

    Layer_Prescription_Map_Dialog.prototype.submitAction = function() {
      return this.validator.validateForm('rx_map');
    };

    Layer_Prescription_Map_Dialog.prototype.getPostData = function() {
      var data;
      data = "id=" + this.loadLayoutPostOptions.id + "&json=" + this.formKO.layer().serialize();
      return data;
    };

    Layer_Prescription_Map_Dialog.prototype.editLayer = function() {
      return this.formKO.setEditing();
    };

    Layer_Prescription_Map_Dialog.prototype.destroy = function() {
      var soil_obj;
      soil_obj = $(this.parent.layoutSelector).find('[data-layertype="soils"]');
      if (soil_obj.parents('tr').data('layer_object') != null) {
        soil_obj.parents('td').trigger('click');
      }
      return Layer_Prescription_Map_Dialog.__super__.destroy.call(this);
    };

    return Layer_Prescription_Map_Dialog;

  })(DialogHandler);

}).call(this);
